import { ref, update } from "firebase/database"
import { db } from "../../firebase"
import { v4 as uuidv4 } from 'uuid';

//both ids are from user id
export async function registerWineryToFarmLog(wineryId, farmId, userId) {
  try {
    const logId = uuidv4()
    await update(ref(db, `logs/${logId}`), {
      id: logId,
      wineryId,
      farmId,
      user_target: wineryId,
      action: 'registerWineryToFarm',
      date: new Date().toISOString(),
      farmResponsibleId: userId,
      read: false,
    })

    return logId
  } catch (err) {
    return []
  }
}